import { TableRow, styled } from "@mui/material";

const DataTableRow = styled(TableRow, {
        shouldForwardProp: (prop) => prop !== 'disablePointer'
    })<{disablePointer?: boolean;}>
    (({ disablePointer }) => ({
        "&:hover": {
            backgroundColor: "#D6E4DF !important",
            cursor: disablePointer ? "default" : "pointer",
        },
    }
));

export default DataTableRow;